import { Controller } from "@hotwired/stimulus"
import { Tab } from "bootstrap"

// Activates a Bootstrap tab whose pane id matches window.location.hash on page load.
export default class extends Controller {
  connect() {
    const hash = window.location.hash
    if (!hash) return
    const pane = this.element.querySelector(hash)
    if (!pane) return
    const tab = this.element.querySelector(`[data-bs-target="${hash}"]`)
    if (tab) Tab.getOrCreateInstance(tab).show()
  }
}
